export default class property_part_css {

    Width: number;
    Height: number;

    css_class_raised: string;
    raised_y: number;

    buyValue: number;
    buyX: number;
    buyY: number;

    //Move positions
    x: number[] = [];
    y: number[] = [];
    moveClass: string[] = [];

    childX: number = 0; //Special case for papakainga
    layer: number = 0;
    pump: boolean = false;
    ownership: boolean = false;

    caravanClass: string = "";

    constructor(c: string, x: number, y: number, width: number, height: number) {
        this.css_class_raised = c;
        this.x.push(x);
        this.y.push(y);
        this.moveClass.push(c);
        this.Width = width;
        this.Height = height;
        this.raised_y = y;
        this.buyValue = this.buyX = this.buyY = 0;
    }

    requiresPump(): property_part_css {
        this.pump = true;
        return this;
    }

    requiresOwnership(): property_part_css {
        this.ownership = true;
        this.layer = -1;
        return this;
    }

    raise(c: string, raiseY: number): property_part_css {
        this.css_class_raised = c;
        this.raised_y = raiseY;
        return this;
    }

    move_relative(x: number, y: number, moveClass: string = ""): property_part_css {
        this.x.push(this.x[0] + x);
        this.y.push(this.y[0] + y);
        if (moveClass) {
            this.moveClass.push(moveClass);
        }
        else {
            this.moveClass.push(this.moveClass[0]);
        }
        return this;
    }

    add_sale_sign(value: number, x: number, y: number): property_part_css {

        this.buyValue = value;
        this.buyX = x;
        this.buyY = y;
        return this;

    }

    damage_class(isCowShed: boolean = false): property_part_css {
        this.caravanClass = isCowShed ? "cow-shed-damaged" : "caravan";
        return this;
    }

    add_child(x: number): property_part_css {
        this.childX = x;
        return this;
    }

}
